<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Types
	import type { Device } from 'src/types/Device';
	//Design system components
	import { AlertV2, ButtonV2, Container, Input, Modal, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { updateFW } from 'src/helpers/firmware_helpers';
	import { isValidURL } from 'src/helpers/utilities';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

	export let device: Device;
	export let showModal = false;
	export let isOffline = false;

	const URL_INPUT_ID = 'firmware-update-from-url';

	let url = '';
	let error = '';
	let waitForResponse = false;

	$: trimmedUrl = url.trim();

	const handleClose = () => {
		url = '';
		error = '';
		showModal = false;
	};

	const handleInput = () => {
		error = '';
	};

	const handleUpdate = async () => {
		if (!isValidURL(trimmedUrl, true)) {
			error = $format('firmware_update_from_url_invalid', {
				default: 'Enter a valid firmware URL.',
			});
			return;
		}

		waitForResponse = true;
		const res = await updateFW(device, trimmedUrl);
		waitForResponse = false;

		if (!res?.isok) {
			error = $format('firmware_update_from_url_rejected', {
				default: 'The device rejected the update request.',
			});
			return;
		}

		setSidePanelState({ open: true });
		handleClose();
	};
</script>

{#if showModal}
	<Modal
		{showModal}
		on:close={handleClose}
		title={$format('firmware_update_from_url_title', {
			default: 'Update firmware from URL',
		})}
	>
		<Container slot="content" padding="0">
			<AlertV2
				class="mb-m"
				customIcon="fas fa-exclamation-triangle text-warning"
				heading={$format('firmware_update_from_url_heading', {
					default: 'This is for custom or test firmware.',
				})}
				isHeadingBold
				message={$format('firmware_update_from_url_message', {
					default: 'Paste a URL you trust. A bad file can leave the device unable to boot.',
				})}
			/>
			<Text styleType="body" class="mb-s">
				{$format('firmware_update_from_url_label', { default: 'Firmware URL' })}
			</Text>
			<Input
				id={URL_INPUT_ID}
				aria-labelledby={URL_INPUT_ID}
				bind:value={url}
				on:input={handleInput}
				{error}
				icon="fal fa-link"
				size="l"
				type="text"
				label="https://…"
				class="width-full"
			/>
		</Container>
		<div class="d-flex justify-content-end" slot="footer">
			<ButtonV2 variant="secondary" class="mr-s" on:click={handleClose}>
				{$format('button_cancel', { default: 'Cancel' })}
			</ButtonV2>
			<ButtonV2
				variant="primary"
				disabled={!trimmedUrl || isOffline}
				loading={waitForResponse}
				on:click={handleUpdate}
			>
				{$format('sub_settings_title_update_firmware', { default: 'Update firmware' })}
			</ButtonV2>
		</div>
	</Modal>
{/if}
